import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { Loader } from 'core/elements';
import { PricingProfileDetails } from 'pricing/components';
import { useGetPricingProfile } from 'pricing/hooks';

export const PricingProfileDetailsPage = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { record, isLoading, isError } = useGetPricingProfile({ id: Number(id) });

  const title = t('titlePricingProfileDetails', { name: record?.name });

  return (
    <PageLayout title={title}>
      {isLoading && <Loader />}

      {isError && <Error statusCode={StatusCode.NOT_FOUND} />}

      {record && <PricingProfileDetails pricingProfile={record} />}
    </PageLayout>
  );
};
